module.exports = __webpack_public_path__ + "img/can-refund.9c1d6c51.svg";